module.exports = __webpack_public_path__ + "static/media/icon_bus_stop_green.63cc85ed.png";